import { cn } from '../../lib/utils'

interface FormColorPickerProps {
  label: string
  value: string
  onChange: (color: string) => void
  className?: string
}

export function FormColorPicker({ label, value, onChange, className = '' }: FormColorPickerProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <label className="block text-sm font-medium text-neutral-700">{label}</label>
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={value}
          onChange={e => onChange(e.target.value)}
          className="w-10 h-10 border border-neutral-200 rounded-lg cursor-pointer p-0.5"
        />
        <input
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          className="flex-1 px-3 py-2 text-sm border border-neutral-200 bg-white text-neutral-900 rounded-lg focus:ring-2 focus:ring-primary-500/15 focus:border-primary-500 transition-colors duration-150 font-mono"
          placeholder="#354ECE"
        />
        <div
          className="w-10 h-10 rounded-lg border border-neutral-200 flex-shrink-0"
          style={{ backgroundColor: value }}
        />
      </div>
    </div>
  )
}
